import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import {env} from '../../config/env';

export default function TermsLinks() {
  return (
    <Typography variant="body2" color="text.secondary" align="center" sx={{mt: 3}}>
      By continuing, you agree to our{' '}
      <Link
        href={`${env.webUrl}/terms`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{color: 'primary.main', textDecoration: 'none'}}
      >
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link
        href={`${env.webUrl}/privacy`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{color: 'primary.main', textDecoration: 'none'}}
      >
        Privacy Policy
      </Link>
    </Typography>
  );
}
